
// export function header1_viewportLeave(event) {
// $w('#whiteHeader').show();
// $w('#columnStrip13').hide();

// }

// export function header1_viewportEnter(event) {
// $w('#whiteHeader').hide();
// $w('#columnStrip13').show();

// }

export function line8_viewportLeave(event) {
	$w('#whiteHeader').show();
    $w('#columnStrip13').hide();
}

export function line8_viewportEnter(event) {
	$w('#whiteHeader').hide();
    $w('#columnStrip13').show(); 
}

